import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Phone,
  PhoneIntel,
} from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '../../services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: Phone, option?) {
    let options: AbstractControlOptions = {};
    const sessionConsultant = option?.sessionConsultant;
    const isCristalisOrganization = option?.isCristalisOrganization || false;

    const formBuilderGroup = this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        userLastName: [entity?.userLastName || null],
        userFirstName: [entity?.userFirstName ? entity.userFirstName : null],
        contactPhones: this.formBuilder.array([
          this.formGroup(isCristalisOrganization, sessionConsultant),
        ]),
      },
      options,
    );
    entity &&
      entity.contactPhones &&
      entity.contactPhones.length > 0 &&
      formBuilderGroup.setControl(
        'contactPhones',
        this.populate(entity, isCristalisOrganization, sessionConsultant),
      );
    return formBuilderGroup;
  }
  generate(entity: Phone[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  populate(data: Phone, isCristalisOrganization, sessionConsultant) {
    let formArray = this.formBuilder.array([
      this.formGroup(isCristalisOrganization, sessionConsultant),
    ]);
    if (data && data.contactPhones) {
      formArray.clear();
      data.contactPhones.forEach((item, index) => {
        formArray.push(
          this.formBuilder.group({
            phone: [
              item,
              [
                isCristalisOrganization && sessionConsultant
                  ? Validators.nullValidator
                  : Validators.required,
                Validators.minLength(9),
              ],
            ],
          }),
        );
      });
    }
    return formArray;
  }
  formGroup(isCristalisOrganization, sessionConsultant): UntypedFormGroup {
    return this.formBuilder.group({
      phone: [
        '',
        [
          isCristalisOrganization && sessionConsultant
            ? Validators.nullValidator
            : Validators.required,
          Validators.minLength(9),
        ],
      ],
    });
  }
  extract() {
    const formValue = this.form.value;
    const owners = formValue.owners.map(item => {
      const phone = this.transformTelephone(item.contactPhones);
      return {
        ...item,
        contactPhones: phone,
      };
    });
    return owners;
  }
  transformTelephone(telephone: PhoneIntel[]) {
    return telephone.map(item => {
      return item?.phone?.e164Number;
    });
  }
}
